import Vue from "vue";
import rate from "vue-rate";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "reset-css";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.use(rate);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
